;(function($){

    function ModalPage() {
   	 	
   	 	var _  = this;
		_.API  = $("#app_url").val() + "/api/";
		_.uri  = null;

		$.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

   	 	$(document).on('click', '.modal', function (event) {
		    event.preventDefault();
		    _.uri  = $(this).attr('href');
		    _.init();
		});
		
    }

    ModalPage.prototype.init = function() {

    	var _ =  this;

    	$("#modal").iziModal({		
			bodyOverflow: true,
			closeOnEscape: false,
			overlayClose: false,
			history: false,
    		autoOpen: true,
			onOpened: function(){
				_.modal.stopLoading(); 	
			},
		    onOpening: function(modal){	

		    	_.modal = modal;

		        modal.startLoading();

		        $.get( _.API + _.uri, function(data) {
		            $("#modal .content").html(data.data);
		            $('#modal').iziModal('setTitle', data.title);		   		 		    
		        });
		    },
		    onClosed: function() {
		    	_.uri  = null;
		    	$("#modal .content").html("");
		        $('#modal').iziModal('setTitle', "");
		    }		 
		});
    }

   	new ModalPage();

}(jQuery));